import { injectCpmsBoRoleApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-role.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoRoleApi = injectCpmsBoRoleApi(baseApi);

export const {
  useCpmsBoCreateRoleMutation,
  useCpmsBoGetRoleQuery,
  useCpmsBoGetRolesPaginatedQuery,
  useCpmsBoUpdateRoleMutation,
} = cpmsBoRoleApi;
